<template>
  <div>
    <div class="background">
      <img :src="imgSrc" width="100%" height="100%" alt="" />
    </div>
    
    <div class="front">
      <el-form
        :rules="rules"
        ref="loginForm"
        :model="loginForm"
        class="loginContainer"
      >
        <h2 class="loginTitle" style="color: cornflowerblue">系统登录</h2>
        <el-form-item prop="userName">
          <el-input
            type="text"
            auto-complete="false"
            v-model="loginForm.userName"
            placeholder="请输入用户名"
            @keyup.enter.native="submitLogin"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="pwd">
          <el-input
            type="password"
            auto-complete="false"
            v-model="loginForm.userPwd"
            placeholder="请输入密码"
            show-password
            @keyup.enter.native="submitLogin"
          >
          </el-input>
        </el-form-item>

        <!-- <el-checkbox v-model="checked" class="loginRemember">记住我</el-checkbox> -->
        <el-button
          type="primary"
          @click="submitLogin"
          style="width: 100%"
          :loading="flag"
        >
          {{ flag ? "登录中..." : "登录" }}
        </el-button>
        <!-- 添加忘记密码链接 -->
        <div style="text-align: right; margin-top: 10px">
          <el-link @click="showForgetPasswordDialog = true">忘记密码?</el-link>
        </div>
        <el-button
          type="text"
          @click="guestLogin"
          style="width: 100%; margin-top: 10px; color: #409EFF"
        >
          匿名用户登录
        </el-button>
      </el-form>
    </div>

    <!-- 忘记密码对话框 -->
    <el-dialog
      :visible.sync="showForgetPasswordDialog"
      title="忘记密码"
      width="30%"
      :before-close="handleClose"
    >
      <template>
        <el-form
          :model="forgetPasswordForm"
          ref="forgetPasswordFormRef"
          :rules="forgetPasswordRules"
        >
          <el-form-item label="邮箱" prop="emailAddress">
            <el-input
              v-model="forgetPasswordForm.emailAddress"
              placeholder="请输入您的邮箱"
            >
              <template slot="append">@yunqingtech.com</template>
            </el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="verificationCode">
            <el-input
              v-model="forgetPasswordForm.verificationCode"
              placeholder="请输入验证码"
            >
              <template slot="append">
                <el-button
                  :disabled="countdown > 0"
                  @click="sendVerificationCode"
                >
                  {{ countdown > 0 ? `${countdown}s` : "发送验证码" }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
        <span>
          <el-button @click="showForgetPasswordDialog = false">取消</el-button>
          <el-button type="primary" @click="submitForgetPassword"
            >提交</el-button
          >
        </span>
      </template>
    </el-dialog>

    <!-- 重置密码对话框 -->
    <el-dialog
      :visible.sync="showResetPasswordDialog"
      title="重置密码"
      width="30%"
      :before-close="handleCloseReset"
    >
      <template>
        <el-form
          :model="resetPasswordForm"
          ref="resetPasswordFormRef"
          :rules="resetPasswordRules"
        >
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              type="password"
              v-model="resetPasswordForm.newPassword"
              placeholder="请输入新密码"
              show-password
            >
            </el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="repeatPassword">
            <el-input
              type="password"
              v-model="resetPasswordForm.repeatPassword"
              placeholder="请再次输入新密码"
              show-password
            >
            </el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
        <span>
          <el-button @click="showResetPasswordDialog = false">取消</el-button>
          <el-button type="primary" @click="submitResetPassword"
            >提交</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getSendCode, getCheckCode, getResetPwd } from "../api/home";
export default {
  name: "Login",
  data() {
    return {
      imgSrc: require("../assets/img/bg-login.jpg"),
      loginForm: {
        userName: "",
        userPwd: "",
      },
      flag: false,
      checked: true,
      rules: {
        userName: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        userPwd: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
      // 忘记密码对话框相关数据
      showForgetPasswordDialog: false,
      forgetPasswordForm: {
        emailAddress: "",
        verificationCode: "",
      },
      forgetPasswordRules: {
        emailAddress: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
          },
        ],
        // verificationCode: [
        //   {
        //     required: true,
        //     message: "请输入验证码",
        //     trigger: "blur",
        //   },
        // ],
      },
      countdown: 0,
      // 重置密码对话框相关数据
      showResetPasswordDialog: false,
      resetPasswordForm: {
        newPassword: "",
        repeatPassword: "",
      },
      resetPasswordRules: {
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur",
          },
          {
            validator: this.validatePassword,
            trigger: "blur",
          },
        ],
        repeatPassword: [
          {
            required: true,
            message: "请确认新密码",
            trigger: "blur",
          },
          {
            validator: this.validateConfirmPassword,
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    const userName = window.sessionStorage.getItem("userName");
    this.loginForm.userName = userName;
  },
  methods: {
    guestLogin() {
      this.loginForm.userName = 'guest'
      this.loginForm.userPwd = '123456'
      this.submitLogin()
    },
    submitLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.flag = true; // 登录中
          this.postRequest2("/user/login", this.loginForm).then((resp) => {
            if (resp) {
              // 登录成功 存储 token 到sessionStorage
              sessionStorage.setItem("userIdStr", resp.result.userIdStr);
              sessionStorage.setItem("chatDialogVisible", "1");
              this.$store.commit("switchChatDialogtip", "1");
              sessionStorage.setItem("userName", resp.result.userName);
              // if (resp.classroomToken) {
              //   // 这里可以根据需要设置不同的 token
              //   sessionStorage.setItem("Authorization", resp.classroomToken);
              //   window.sessionStorage.setItem(
              //     "classRoomUid",
              //     resp.classroom.id
              //   );
              // }
              window.sessionStorage.setItem("userRoleId", resp.result.rodeId);
              window.sessionStorage.setItem("departmentId",resp.result.departmentId);
              window.sessionStorage.setItem("uid", resp.result.uid);
              // 获取项目信息并存储到 sessionStorage
              this.getRequest("/dim/project?flag=false").then((resp) => {
                if (resp) {
                  this.saveDictCache("projects", resp.result);
                }
              });
              this.$nextTick(() => {
                this.$router.replace({ path: "/home" });
              });
              //  表单方式发送用户名、密码
            }
            this.flag = false;
          });
        } else {
          this.$message.error("请输入所有字段！");
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 发送验证码
    sendVerificationCode() {
      this.$refs["forgetPasswordFormRef"].validate((valid) => {
        if (valid) {
          // 确保邮箱地址完整
          const email =
            this.forgetPasswordForm.emailAddress + "@yunqingtech.com";
          getSendCode(email)
            .then((resp) => {
              if (resp.code == 200) {
                this.$message.success("验证码已发送，请检查您的邮箱");
                this.countdown = 180;
                const intervalId = setInterval(() => {
                  this.countdown--;
                  if (this.countdown === 0) {
                    clearInterval(intervalId);
                  }
                }, 1000);
              } else {
                this.$message.error("发送验证码失败，请稍后重试");
              }
            })
            .catch((error) => {
              // 处理接口调用错误
              this.$message.error("发送验证码时出现错误，请检查网络或稍后重试");
            });
        } else {
          // 处理表单验证不通过的情况
          this.$message.error("请输入有效的邮箱地址");
        }
      });
    },
    // 提交忘记密码表单
    submitForgetPassword() {
      this.$refs.forgetPasswordFormRef.validate((valid) => {
        if (valid) {
          // 这里调用后端接口重置密码
          let params = {
            emailAddress:
              this.forgetPasswordForm.emailAddress + "@yunqingtech.com",
            code: this.forgetPasswordForm.verificationCode,
          };

          getCheckCode(params).then((resp) => {
            if (resp.code == 200) {
              this.$message.success("验证码验证成功，请重置密码");
              setTimeout(() => {
                this.showForgetPasswordDialog = false;
                this.showResetPasswordDialog = true;
              }, 1500);
            }
          });
        }
      });
    },
    // 验证密码强度
    validatePassword(rule, value, callback) {
      const passwordRegex =
        /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\._\+(){}])[0-9a-zA-Z!@#$%^&*,\\._\+(){}]{8,20}$/;
      if (!passwordRegex.test(value)) {
        callback(
          new Error("密码需包含字母、数字和特殊字符，且长度至少为 8 位")
        );
      } else {
        callback();
      }
    },
    // 验证确认密码
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.resetPasswordForm.newPassword) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    },
    // 处理重置密码对话框关闭
    handleCloseReset(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 提交重置密码表单
    submitResetPassword() {
      this.$refs.resetPasswordFormRef.validate((valid) => {
        if (valid) {
          // 这里调用后端接口更新密码
          let params = {
            emailAddress:
              this.forgetPasswordForm.emailAddress + "@yunqingtech.com",
            repeatPassword: this.resetPasswordForm.repeatPassword,
            newPassword: this.resetPasswordForm.newPassword,
          };
          getResetPwd(params).then((resp) => {
            if (resp.code == 200) {
              setTimeout(() => {
                this.$message.success("密码重置成功，请使用新密码登录");
                this.showResetPasswordDialog = false;
              }, 1500);
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.background {
  width: 100%;
  height: 100%;
  z-index: -1;
  position: absolute;
}
.el-input-group {
  width: 55%;
}
.front {
  z-index: 1;
  position: absolute;
  left: 38%;
  top: 20%;
}

.loginContainer {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 120px auto;
  width: 350px;
  padding: 15px 35px 25px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  color: red;
}

.loginTitle {
  margin: 40px auto 30px auto;
  text-align: center;
}

.loginRemember {
  text-align: left;
  margin: 0px 0px 15px 0px;
}

.el-form-item__content {
  display: flex;
  align-items: center;
}
::v-deep .el-input__inner {
  min-width: 70px !important;
}
</style>

<!-- https://blog.csdn.net/weixin_38166931/article/details/99641021   axios异步提交表单数据的不同形式 -->
<!-- https://www.cnblogs.com/jszhp/p/10142904.html -->
